import { Metric } from './metric';

export interface UserStatistics {
  totalCount: number;
  activeCount: number;
  inactiveCount: number;
}

export namespace UserStatistics {
  export function mapToMetrics(statistics: UserStatistics): Metric[] {
    return [
      {
        label: 'users.totalUsers',
        value: statistics.totalCount,
        icon: 'people',
        iconSize: 1.375,
      },
      {
        label: 'users.activeUsers',
        value: statistics.activeCount,
        icon: 'sunny',
        iconSize: 1.375,
      },
      {
        label: 'users.inactiveUsers',
        value: statistics.inactiveCount,
        icon: 'bedtime',
        iconSize: 1.375,
      },
    ];
  }
}
